import { render, staticRenderFns } from "./TruckTotals.vue?vue&type=template&id=6d10b1fa&scoped=true"
import script from "./TruckTotals.vue?vue&type=script&lang=js"
export * from "./TruckTotals.vue?vue&type=script&lang=js"
import style0 from "./TruckTotals.vue?vue&type=style&index=0&id=6d10b1fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d10b1fa",
  null
  
)

export default component.exports